<template>
  <BasePageContainer class="pt-9 pt-lg-4">
    <div class="page goal pb-8">
      <GoalListMandalaSection
        v-if="!isConditionButtonActive"
        :key="selectedYearMonthStr"
        :member-id="memberId"
        :initial-year-month-date="mandalaSectionYearMonthDate" />
      <div class="d-flex justify-content-between pb-3">
        <TextButtonWithCaret
          caret-position="left"
          @click="toPrevMonth">
          前月
        </TextButtonWithCaret>
        <GoalListDatepicker
          v-model="_selectedDate" />
        <TextButtonWithCaret
          v-if="!isSelectedDateToday"
          caret-position="right"
          @click="toToday">
          今日
        </TextButtonWithCaret>
        <div
          v-else
          style="width: 54px;" />
      </div>
      <ul
        v-if="hasGoalItems"
        class="list-unstyled pb-3">
        <goal-card
          v-for="goal in goalItems"
          :key="goal.id"
          :ref="'goal-' + goal.id"
          :member-id="memberId"
          :goal="goal"
          :selected-date="formattedSelectedDate"
          :end-of-selected-date="endOfSelectedDate"
          :login-user-id="user.id"
          :is-show-detail="goal.isShowDetail"
          :is-period-over="isPeriodOver"
          :attachment-option="attachmentOption"
          :lock-goal-option="lockGoalOption"
          class="goal-card p-3 mb-3"
          @showGoalDetail="showGoalDetail"
          @showActivityDetail="showActivityDetail">
          <template #activity>
            <goal-card-activity-panel
              v-for="activity in goal.activities"
              :key="activity.id"
              :ref="'activity-' + activity.id"
              :member-id="memberId"
              :login-user-id="user.id"
              :is-period-over="isPeriodOver"
              :is-parent-member="isParentMember"
              :goal-id="goal.id"
              :is-show-detail="activity.isShowDetail"
              :attachment-option="attachmentOption"
              :activity="activity"
              :condition-setting="goal.conditionSetting"
              :body-pain-setting="goal.bodyPainSetting"
              @showActivityDetail="showActivityDetail"
              @like="onLike"
              @dislike="onDislike"
              @like-count="onLikeCount">
              <template #comment>
                <comment-panel
                  v-if="!activity.isDraft"
                  ref="form"
                  :activity-id="activity.id"
                  :comments="activity.comments"
                  :login-user-id="user.id"
                  :attachment-option="attachmentOption"
                  :is-period-over="isPeriodOver"
                  @createComment="(...values) => createComment(goal.id, ...values)"
                  @deletedComment="(...values) => deletedComment(goal.id, ...values)" />
              </template>
            </goal-card-activity-panel>
          </template>
        </goal-card>
      </ul>
      <div
        v-else
        class="d-flex justify-content-center py-2">
        {{ emptyStateNotification }}
      </div>

      <div
        v-if="isLoginUser && !isPeriodOver"
        class="goal__add text-right">
        <button
          class="goal__add-btn btn--circle-l btn-l-blue"
          @click="onClickAddGoalBtn">
          <span class="goal__add-icon material-icons">
            add
          </span>
        </button>
      </div>

      <b-toast
        id="period-over-toast"
        :visible="isPeriodOver"
        no-auto-hide
        variant="info"
        solid>
        <template #toast-title>
          <div class="d-flex flex-grow-1 align-items-baseline">
            <strong class="mr-auto">契約期間が終了しています</strong>
          </div>
        </template>
        管理者に確認して下さい。
      </b-toast>
      <b-modal
        id="like-users-modal"
        hide-header
        hide-footer
        body-class="like-modal">
        <div
          class="like-modal-cross">
          <b-icon-x-circle-fill
            style="cursor: pointer;"
            @click="onLikeModalHide" />
        </div>
        <div class="text--grey05 d-flex align-items-center mt-3">
          <span
            class="material-icons mr-1 like-btn"
            style="font-size: 1rem;">thumb_up</span>
          <span>いいねした人</span>
        </div>

        <div class="mt-3">
          <div v-if="likeUsers && likeUsers.length > 0">
            <app-list-item
              v-for="likeUser in likeUsers"
              :key="likeUser.id"
              :avatar="likeUser.avatar"
              :name="likeUser.name"
              :group="likeUser.department.name"
              :position="likeUser.position" />
          </div>
          <p
            v-else
            style="font-size: 14px;">
            この活動にはまだいいねがありません
          </p>
        </div>
      </b-modal>
    </div>
    <FixedBottomLeftArea>
      <FixedBottomLeftButton
        v-if="isAnyManager && isLoginUser"
        icon="people"
        class="d-lg-none"
        data-testid="record-list-button"
        @click="$router.push({ name: 'recordList' })">
        記録一覧
      </FixedBottomLeftButton>
      <FixedBottomLeftButton
        v-else-if="showFooterMyDataButton"
        icon="edit_document"
        class="d-lg-none"
        @click="$router.push(`/members/${memberId}/profile`)">
        マイデータ
      </FixedBottomLeftButton>
      <FixedBottomLeftButton
        v-if="isAnyManager && isLoginUser"
        icon="edit_note"
        large-icon
        color="grey"
        class="d-lg-none"
        data-testid="template-management-button"
        @click="$router.push('/admin/template_management/')">
        テンプレ
      </FixedBottomLeftButton>
      <FixedBottomLeftButton
        v-if="showMembersReturnButton"
        icon="undo"
        @click="goBackToMembers">
        リストに戻る
      </FixedBottomLeftButton>
      <FixedBottomLeftButton
        v-if="showNotificationReturnButton"
        icon="undo"
        @click="goBackToNotifications">
        通知に戻る
      </FixedBottomLeftButton>
    </FixedBottomLeftArea>
  </BasePageContainer>
</template>

<script>
import GoalCard from '@/components/parts/GoalCard.vue'
import AppListItem from '@/components/parts/AppListItem.vue'
import GoalListMandalaSection from '@/components/view/GoalListMandalaSection.vue'
import GoalCardActivityPanel from '@/components/parts/GoalCardActivityPanel.vue'
import CommentPanel from '@/components/parts/CommentPanel'
import GoalListDatepicker from '@/components/parts/GoalListDatepicker.vue'
import TextButtonWithCaret from '@/components/parts/TextButtonWithCaret.vue'
import FixedBottomLeftArea from '@/components/parts/FixedBottomLeftArea.vue'
import FixedBottomLeftButton from '@/components/parts/FixedBottomLeftButton.vue'
import { mapState, mapGetters } from 'vuex'
import { format, formatISO, endOfDay, endOfMonth, subMonths, isSameDay } from 'date-fns'
import { isInvalidDate } from '@/utils/datetime'
import confirmIfFormsChanged from '@/components/mixin/confirmIfFormsChanged'
import notificationReturn from '@/components/mixin/notificationReturn'
import membersReturn from '@/components/mixin/membersReturn'

export default {
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.isConditionButtonActive) {
      this.$store.commit('toggleIsConditionButtonActive')
    }
    next()
  },
  components: {
    GoalCard,
    AppListItem,
    GoalListMandalaSection,
    GoalCardActivityPanel,
    CommentPanel,
    GoalListDatepicker,
    TextButtonWithCaret,
    FixedBottomLeftArea,
    FixedBottomLeftButton,
  },
  mixins: [confirmIfFormsChanged(), notificationReturn, membersReturn],
  data() {
    return {
      goals: [],
      fetchCompleted: false,
      period: new Date(),
      attachmentOption: false,
      lockGoalOption: false,
      likeUsers: [],
      mandalaSectionYearMonthDate: new Date(),
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState(['isConditionButtonActive', 'isLoading', 'selectedDate']),
    ...mapGetters('auth', ['isParentMember', 'isManager', 'isAnyManager']),
    _selectedDate: {
      get() {
        return this.selectedDate
      },
      set(date) {
        this.$store.commit('setSelectedDate', date)
      }
    },
    hasGoalItems() {
      return this.goalItems.length > 0
    },
    emptyStateNotification() {
      // goalItemsがまだ取得できてないときに何らかの文字が表示されるのを防止
      if (!this.fetchCompleted) return ''
      if (this.goals.length === 0) return '青いプラスボタンからノートを作りましょう'
      return '今月のコンディション記録・痛みの記録はありません'
    },
    memberId() {
      return this.$route.params.id
    },
    isLoginUser() {
      return this.user.id === this.memberId
    },
    showFooterMyDataButton() {
      if (this.isManager) return !this.isLoginUser
      return !this.isParentMember && this.isLoginUser
    },
    formattedSelectedDate() {
      return this.formatDate(this.selectedDate)
    },
    selectedYearMonthStr() {
      return format(this.selectedDate, 'yyyy-MM')
    },
    endOfSelectedDate() {
      const end = endOfDay(this.selectedDate)
      return formatISO(end)
    },
    mandalaSectionInitialDate() {
      const mandalaSectionInitialDate = new Date(this.$route.query.mandalaSectionInitialDate)
      return isInvalidDate(mandalaSectionInitialDate) ? this.selectedDate : mandalaSectionInitialDate
    },
    goalItems() {
      if (this.isConditionButtonActive) {
        return this.goalsHasConditions
      }
      return this.goals
    },
    goalsHasConditions(){
      // 本日かつコンディションがある活動記録のみを取得するための条件
      const hasConditions = (activity) => {
        const hasConditions = activity.conditionSetting?.items.length > 0 || activity.bodyPainSetting?.isRecordBodyPain
        return hasConditions
      }
      const goals = this.goals.filter(goal => {
        if (goal.activities.length <= 0) return false
        return goal.activities.some(hasConditions)
      })
      return goals.map(goal => {
        return {
          ...goal,
          activities: goal.activities.filter(hasConditions)
        }
      })
    },
    query() {
      return this.$route.query
    },
    isPeriodOver(){
      const period = endOfDay(new Date(this.period))
      const today = new Date()
      if (period < today){
        return true
      }
      return false
    },
    isSelectedDateToday() {
      return isSameDay(this.selectedDate, new Date())
    }
  },
  watch: {
    selectedYearMonthStr() {
      this.mandalaSectionYearMonthDate = this.selectedDate
    },
    async selectedDate(){
      // 日付を変更したらtodayをfalseにする
      if (this.$store.state.isConditionButtonActive) {
        this.$store.commit('toggleIsConditionButtonActive')
      }
      // nowが変わったら諸々取得
      await this.fetchAll()
    },
    isConditionButtonActive(val) {
      if (!val) return
      for (const goal of this.goals) {
        if (goal.conditionSetting || goal.bodyPainSetting) {
          goal.isShowDetail = true
        }
      }
    }
  },
  created() {
    // リアクティブにしないためdataではなくインスタンスプロパティとして初期化
    this.scrollTimeoutId = null
  },
  beforeDestroy() {
    clearTimeout(this.scrollTimeoutId)
  },
  mounted() {
    this.mandalaSectionYearMonthDate = this.mandalaSectionInitialDate
    if (this.query.goalEndDate){
      this.$store.commit('setSelectedDate', new Date(this.query.goalEndDate))
    }
    else {
      this.$store.commit('setSelectedDate', new Date())
    }
  },
  methods: {
    formatDate(date) {
      return format(date, 'yyyy-MM-dd')
    },
    scrollToRef(refKey) {
      const refs = this.$refs[refKey]
      if (refs && refs[0] && refs[0].$el) {
        refs[0].$el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    scrollToQueryTarget() {
      clearTimeout(this.scrollTimeoutId)
      if (!this.query.goalId && !this.query.activityId) return
      // CSS トランジション等の完了を待ってからスクロールする（fire-and-forget）
      this.$nextTick().then(() => {
        this.scrollTimeoutId = setTimeout(() => {
          if (this.query.activityId) {
            this.scrollToRef('activity-' + this.query.activityId)
          } else if (this.query.goalId) {
            this.scrollToRef('goal-' + this.query.goalId)
          }
        }, 300)
      })
    },
    async fetchAll() {
      this.$store.commit('startLoading')
      this.fetchCompleted = false
      this.goals = []
      const tenantInfo = await this.$axios.get('/tenants/')
        .then((res) => {
          return res.data
        })
        .catch((e) => {
          console.error(e)
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
          this.$store.commit('finishLoading')
          return null
        })
      if (!tenantInfo) return
      this.period = tenantInfo.period
      this.attachmentOption = tenantInfo.attachmentOption
      this.lockGoalOption = tenantInfo.lockGoalOption
      // 目標
      const resultGoals = await this.fetchGoals()
        .catch((e) => {
          console.error(e)
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
          this.$store.commit('finishLoading')
          return
        })
      this.goals = await Promise.all(resultGoals.map(async v => {
        const goal = Object.assign({}, v)
        const workAt = this.endOfSelectedDate

        // 活動記録および活動記録の下書き
        const activitiesAndDrafts = await Promise.all([this.fetchActivities(goal.id, workAt), this.fetchActivityDrafts(goal.id)])
          .then((results) => {
            return results
              .reduce((a, b) => a.concat(b), [])
              .sort((a, b) => {
                if (a.workAt > b.workAt) return -1
                return 1
              })
          }).catch((e) => {
            console.error(e)
            this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
            this.$store.commit('finishLoading')
          })

        if (!activitiesAndDrafts) {
          return
        }
        goal.activities = activitiesAndDrafts.map(x =>{
          const activity = Object.assign({}, x)
          // queryにactivitiyIdが指定されている場合は展開して表示する。
          if (this.query.activityId && this.query.activityId === activity.id) {
            activity.isShowDetail = true
          } else {
            activity.isShowDetail = false
          }
          return activity
        })

        goal.totalActivityCount = goal.activities.reduce((a, c)=> {return a + c.resultCount}, 0)

        // queryにgoalIdが指定されている場合は展開して表示する。
        if (this.query.goalId && this.query.goalId ===goal.id) {
          goal.isShowDetail = true
        } else {
          goal.isShowDetail = false
        }

        return goal
      }))
      this.fetchCompleted = true
      this.$store.commit('finishLoading')
      this.scrollToQueryTarget()
    },
    async fetchGoals(){
      const restGoals = await this.$axios.get(`/goals/?start_date__lte=${this.formattedSelectedDate}&end_date__gte=${this.formattedSelectedDate}&created_by=${this.memberId}&ordering=-pin,created_at`)
        .catch((e) => {throw e})
      return restGoals.data.results
    },
    async fetchActivities(goalId, workAt){
      const restActivities = await this.$axios.get('/activities/activity_results/', {
        params: {
          limit: 99999,
          goal: goalId,
          work_at__lte: `${workAt}`,
          ordering: '-work_at'
        }
      })
        .catch((e) => {throw e})
      return restActivities.data.results.map(activity => {
        activity.isDraft = false
        return activity
      })
    },
    async fetchActivityDrafts(goalId){
      const restDraft = await this.$axios.get(`/goals/${goalId}/activity_drafts/`)
        .catch((e) => {throw e})
      return restDraft.data.results.map(draft => {
        draft.isDraft = true
        return draft
      })
    },
    async fetchComments(activitiyId){
      // 作成日の昇順で並べたコメントを返す
      const comments = await this.$axios.get(`/activities/comments/?activity_result=${activitiyId}&ordering=created_at`)
        .then((res) => res.data.results)
        .catch((e) => {throw e})
      return comments
    },
    onClickAddGoalBtn() {
      this.$router.push(`${this.memberId}/goal_add`)
    },
    onHasSelectedDateActivity(v) {
      this.selectedDateGoals.push(v)
    },
    // emit
    // コメント追加
    async createComment(goalId, activityId, text, file){
      const formData = new FormData()
      formData.append('detail', text)
      formData.append('activity_result', activityId)
      if (file) {
        formData.append('file', file)
      }
      this.$store.commit('startLoading')
      try {
        await this.$axios.post('/activities/comments/', formData)
        const resultComments = await this.fetchComments(activityId)
        const activity = this.goals.find(v=>v.id === goalId).activities.find(v=>v.id===activityId)
        activity.comments = resultComments
      } catch (e) {
        console.error(e)
        console.error('e.response', e.response)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }
      this.$store.commit('finishLoading')

    },
    // コメント削除
    async deletedComment(goalId, activitiyId, commentId){
      if (!window.confirm('コメントを削除してもよろしいですか?')) return
      this.$store.commit('startLoading')
      await this.$axios.delete(`/activities/comments/${commentId}/`).then(() => {
        this.$store.commit('notify/set', {message: 'コメントを削除しました。'})
      }).catch((e) => {
        console.error(e)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })

      const resultComments = await this.fetchComments(activitiyId)
        .catch((e) => {
          console.error(e)
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        })
      const activity = this.goals.find(v=>v.id === goalId).activities.find(v=>v.id===activitiyId)
      activity.comments = resultComments

      this.$store.commit('finishLoading')
    },
    // 目標展開
    showGoalDetail(id){
      const goal = this.goals.find(v=> v.id === id)
      goal.isShowDetail = !goal.isShowDetail
    },
    // 活動記録展開
    showActivityDetail(goalId, activityId){
      const goal = this.goals.find(v=> v.id === goalId)
      const activity = goal.activities.find(v=> v.id === activityId)
      activity.isShowDetail = !activity.isShowDetail
    },
    async onLike(activityId) {
      await this.$axios.post(`/activities/activity_results/${activityId}/like/`).catch((e) => {
        console.error(e)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })
    },
    async onDislike(activityId) {
      await this.$axios.post(`/activities/activity_results/${activityId}/dislike/`).catch((e) => {
        console.error(e)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })
    },
    async onLikeCount(activityId) {
      this.$store.commit('startLoading')
      this.likeUsers = await this.fetchLikeUsers(activityId).catch((e) => {
        console.error(e)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })
      this.$bvModal.show('like-users-modal')
      this.$store.commit('finishLoading')
    },
    async fetchLikeUsers(activityId) {
      const resultLikeUsers = await this.$axios.get(`/activities/activity_results/${activityId}/like_users/`)
        .then((res) => res.data.results)
        .catch(e => {throw e})
      return resultLikeUsers
    },
    onLikeModalHide() {
      this.$bvModal.hide('like-users-modal')
    },
    onClickConditionButton() {
      this.$store.commit('toggleIsConditionButtonActive')
    },
    toPrevMonth() {
      this.$store.commit('setSelectedDate', endOfMonth(subMonths(this.selectedDate, 1)))
    },
    toToday() {
      this.$store.commit('setSelectedDate', new Date())
    }
  }
}
</script>

<style lang="scss" scoped>
.goal{
  &__head{
    background-color: $white;
    border-bottom: solid 1px $grey11;
  }
  &__add{
    @media screen and (min-width:992px) {
      position: fixed;
      right: 16px;
      bottom: 120px;
    }
  }
  &__add-btn{
    box-shadow: 1px 2px 6px $grey05;
  }
  &__add-icon{//ボタン
    font-size: 30px;
    line-height: 54px;
    width: 30px;
  }
  .condition-button {
    @media screen and (min-width:992px) {
      position: fixed;
      right: 16px;
      bottom: 50px;
    }
    @media screen and (max-width:991px) {
      display: none;
    }
  }
}

.calendar{
  &__btn{
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: $white;
    vertical-align: middle;
    display: inline-block;
    color: $black;
    border: none;
    padding-top: 0px;
    padding-bottom: 0px;
    &--previous{
      padding-left: 6px;
    }
    &--next{
      padding-left: 6px;
    }
  }
  &__icon{
    line-height: 36px;
  }
  &__date{
    font-size: $fs-nm;
    font-weight: bold;
    line-height: 36px;
  }
}

.goal-card{
  background-color: $white;
  border-radius: 8px;
  position: relative;
}

.datepicker_now ::v-deep  > button{
  position: absolute;
}
.datepicker_now ::v-deep >button > svg{
  display: none;
}

.datepicker_now ::v-deep label{
  background-color :$grey02 !important;
  font-size: 16px;
  font-weight: 700;
}
.period-over{
  background-color: $grey03;
  margin: auto;
  padding: 20px 20px 20px;
  border-radius: 5px;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}

.like-modal {
  position: relative;
}

.like-modal-cross {
  position: absolute;
  top: 5px;
  right: 5px;
  display: flex;
  justify-content: flex-end;
  font-size: 20px;
  color: $grey04;
}

</style>